<template>
  <div class="threshold-form-container">
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px">
        {{ isEdit ? "修改阈值" : "新增阈值" }}
      </span>
      <!-- 只有新增页面才有导入按钮 -->
      <el-upload
        v-if="!isEdit"
        class="upload-demo"
        style="float: right; margin-top: -5px;"
        action=""
        accept=".json"
        :show-file-list="false"
        :before-upload="beforeUpload"
      >
        <el-button size="small" type="success" plain>导入</el-button>
      </el-upload>
    </div>

    <div class="form-container" style="margin-top: 30px;">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <!-- 阈值名称 -->
        <el-form-item label="阈值名称" prop="name">
          <el-row>
            <el-col :span="12">
              <el-input
                v-model="form.name"
                :placeholder="isEdit ? '请输入阈值名称' : '请输入阈值名称'"
                clearable
                :disabled="isEdit"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="所属项目" prop="projectId">
          <el-select
            size="small"
            filterable
            style="width: 160px"
            v-model="form.projectId"
            v-el-select-loadmore="loadMore"
            placeholder="请选择所属项目"
          >
            <el-option
              v-for="item in project.list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 阈值列表 -->
        <el-form-item label="阈值配置" prop="configs">
          <div style="margin-left: 20px; margin-bottom: 10px;">
            <span style="color: #666; font-size: 12px;">
              共 {{ form.configs.length }} 个阈值配置
            </span>
          </div>
          <el-row style="margin-left: 20px">
            <el-col :span="1">
              <span>排序</span>
            </el-col>
            <el-col :span="6">
              <span>阈值Key</span>
            </el-col>
            <el-col :span="6">
              <span>阈值Value</span>
            </el-col>
            <el-col :span="7">
              <span>阈值描述（可选）</span>
            </el-col>
            <el-col :span="4">
              <span>操作</span>
            </el-col>
          </el-row>

          <div
            v-for="(item, index) in form.configs"
            :key="index"
            class="threshold-row"
            :draggable="form.configs.length > 1"
            @dragstart="onDragStart(index)"
            @dragover.prevent="onDragOver(index)"
            @drop="onDrop(index)"
            @dragend="onDragEnd"
          >
            <el-row style="margin-left: 20px; margin-top: 10px;">
              <el-col :span="1">
                <div class="drag-handle" style="cursor: move;">
                  <i
                    class="el-icon-rank"
                    style="font-size: 20px; color: #909399;"
                  ></i>
                </div>
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="item.key"
                  placeholder="阈值Key"
                  style="width: 90%"
                ></el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="item.value"
                  placeholder="阈值Value"
                  style="width: 90%"
                ></el-input>
              </el-col>
              <el-col :span="7">
                <el-input
                  v-model="item.description"
                  placeholder="阈值描述"
                  style="width: 90%"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <div class="action-buttons">
                  <!-- 上移按钮 -->
                  <el-button
                    v-if="index > 0"
                    type="text"
                    size="mini"
                    @click="moveUp(index)"
                    title="上移"
                  >
                    <i
                      class="el-icon-top"
                      style="color: #409EFF; font-size: 18px;"
                    ></i>
                  </el-button>

                  <!-- 下移按钮 -->
                  <el-button
                    v-if="index < form.configs.length - 1"
                    type="text"
                    size="mini"
                    @click="moveDown(index)"
                    title="下移"
                  >
                    <i
                      class="el-icon-bottom"
                      style="color: #409EFF; font-size: 18px;"
                    ></i>
                  </el-button>

                  <!-- 删除按钮 -->
                  <el-button
                    type="text"
                    size="mini"
                    @click="deleteConfig(index)"
                    title="删除"
                    :disabled="form.configs.length <= 1"
                  >
                    <i
                      class="el-icon-remove-outline"
                      style="color: #F56C6C; font-size: 20px;"
                    ></i>
                  </el-button>

                  <!-- 添加按钮 -->
                  <el-button
                    v-if="index === form.configs.length - 1"
                    type="text"
                    size="mini"
                    @click="addConfig"
                    title="添加"
                  >
                    <i
                      class="el-icon-circle-plus-outline"
                      style="color: #67C23A; font-size: 20px;"
                    ></i>
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div
      class="btns"
      style="margin-top: 30px; display: flex; align-items: center; justify-content: center;"
    >
      <el-button @click="cancel" class="resetbtn">取消</el-button>
      <el-button type="success" @click="save" style="margin-left: 20px;"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  getThresholdDetail,
  addThreshold,
  updateThreshold
} from "@/store/threshold";

export default {
  name: "ThresholdForm",
  data() {
    // 阈值名称校验
    const validateThresholdName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入阈值名称"));
      }
      if (value.length < 2 || value.length > 50) {
        return callback(new Error("阈值名称长度在 2 到 50 个字符"));
      }
      callback();
    };

    // 阈值配置校验（阈值描述改为可选）
    const validateConfigs = (rule, value, callback) => {
      if (!value || value.length === 0) {
        return callback(new Error("请至少添加一个阈值配置"));
      }

      // 检查是否有重复的key
      const keys = value.map(item => item.key);
      const uniqueKeys = new Set(keys);
      if (uniqueKeys.size !== keys.length) {
        return callback(new Error("阈值Key不能重复"));
      }

      // 检查每个配置项（只验证key和value，description不验证）
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        if (!item.key) {
          return callback(new Error(`第${i + 1}个配置缺少阈值Key`));
        }
        if (!item.value && item.value !== 0) {
          return callback(new Error(`第${i + 1}个配置缺少阈值Value`));
        }
        // Key格式校验（字母开头，可包含字母、数字和下划线）
        const keyRegex = /^[a-zA-Z][a-zA-Z0-9_]*$/;
        if (!keyRegex.test(item.key)) {
          return callback(
            new Error(
              `第${i + 1}个配置的Key只能以字母开头，包含字母、数字和下划线`
            )
          );
        }
      }

      callback();
    };

    return {
      form: {
        id: undefined,
        name: "",
        projectId: "",
        configs: [{ key: "", value: "", description: "" }]
      },
      project: {
        total: 0,
        list: [],
        pageNo: 1
      },
      rules: {
        name: [
          { required: true, validator: validateThresholdName, trigger: "blur" }
        ],
        configs: [
          { required: true, validator: validateConfigs, trigger: "blur" }
        ],
        projectId: [
          { required: true, message: "请选择所属项目", trigger: "change" }
        ]
      },
      // 拖拽相关
      draggingIndex: -1,
      dragOverIndex: -1,
      isEdit: false
    };
  },

  created() {
    const id = this.$route.params.id;
    if (id) {
      this.isEdit = true;
      this.loadThresholdData(id);
    }
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          // console.log(
          //   `scrollTop: ${scrollTop}, scrollHeight: ${scrollHeight}, clientHeight: ${clientHeight}`
          // );

          if (Math.abs(scrollHeight - scrollTop - clientHeight) < 1) {
            binding.value(); // 触发加载更多
          }
        });
      }
    }
  },
  methods: {
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("device/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));
          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },
    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
        console.log("loadMore!");
      }
    },
    // 加载阈值数据
    async loadThresholdData(id) {
      try {
        const response = await getThresholdDetail(id);

        const transformedConfigs = (response.configs || []).map(item => ({
          key: item.configKey || "",
          value: item.configValue || "",
          description: item.configDescription || "",
          order: item.configOrder || 1
        }));
        this.form = {
          id: response.thresholdId,
          projectId: response.projectId,
          name: response.name || "",
          configs:
            transformedConfigs.length > 0
              ? transformedConfigs
              : [{ key: "", value: "", description: "" }]
        };
      } catch (error) {
        console.error("加载阈值数据失败:", error);
        this.$message.error("加载阈值数据失败");
      }
    },

    cancel() {
      this.$router.go(-1);
    },

    deleteConfig(index) {
      if (this.form.configs.length <= 1) {
        this.$message.warning("至少需要保留一个阈值配置");
        return;
      }
      this.form.configs.splice(index, 1);
    },

    addConfig() {
      this.form.configs.push({
        key: "",
        value: "",
        description: ""
      });
    },

    // 上移一行
    moveUp(index) {
      if (index <= 0) return;
      this.swapItems(index, index - 1);
    },

    // 下移一行
    moveDown(index) {
      if (index >= this.form.configs.length - 1) return;
      this.swapItems(index, index + 1);
    },

    // 交换两个位置
    swapItems(fromIndex, toIndex) {
      const temp = this.form.configs[fromIndex];
      this.$set(this.form.configs, fromIndex, this.form.configs[toIndex]);
      this.$set(this.form.configs, toIndex, temp);
    },

    // 拖拽开始
    onDragStart(index) {
      if (this.form.configs.length <= 1) return;
      this.draggingIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", index);

      // 添加拖拽视觉效果
      setTimeout(() => {
        event.target.style.opacity = "0.5";
      }, 0);
    },

    // 拖拽经过
    onDragOver(index) {
      if (this.draggingIndex === -1) return;
      if (this.draggingIndex !== index) {
        this.dragOverIndex = index;
      }
    },

    // 拖拽放下
    onDrop(index) {
      if (this.draggingIndex === -1 || this.draggingIndex === index) return;

      // 执行位置交换
      const fromIndex = this.draggingIndex;
      const toIndex = index;

      if (fromIndex < toIndex) {
        // 向下移动
        const temp = this.form.configs[fromIndex];
        for (let i = fromIndex; i < toIndex; i++) {
          this.$set(this.form.configs, i, this.form.configs[i + 1]);
        }
        this.$set(this.form.configs, toIndex, temp);
      } else {
        // 向上移动
        const temp = this.form.configs[fromIndex];
        for (let i = fromIndex; i > toIndex; i--) {
          this.$set(this.form.configs, i, this.form.configs[i - 1]);
        }
        this.$set(this.form.configs, toIndex, temp);
      }

      this.draggingIndex = -1;
      this.dragOverIndex = -1;
    },

    // 拖拽结束
    onDragEnd() {
      this.draggingIndex = -1;
      this.dragOverIndex = -1;
      event.target.style.opacity = "";
    },

    async save() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        this.$message.error("表单验证失败，请检查填写内容");
        return;
      }

      // 构建提交数据（包含排序信息）
      const submitData = {
        name: this.form.name,
        projectId: this.form.projectId,
        configs: this.form.configs.map((item, index) => ({
          ...item,
          order: index + 1 // 添加排序字段
        }))
      };

      // 如果有ID，则是编辑操作

      if (this.form.id) {
        submitData.thresholdId = this.form.id;
      }

      try {
        if (this.isEdit) {
          await updateThreshold(submitData);
          this.$message.success("阈值更新成功");
        } else {
          await addThreshold(submitData);
          this.$message.success("阈值添加成功");
        }
        this.$router.go(-1);
      } catch (error) {
        this.$message.error("操作失败：" + (error || "未知错误"));
      }
    },

    resetForm() {
      this.form = {
        id: undefined,
        name: "",
        configs: [{ key: "", value: "", description: "" }]
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },

    // 上传前的校验
    beforeUpload(file) {
      const fileName = file.name;
      const fileType = fileName
        .substring(fileName.lastIndexOf(".") + 1)
        .toLowerCase();

      if (fileType !== "json") {
        this.$message.error("只能上传 JSON 文件！");
        return false;
      }

      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }

      // 手动读取文件
      this.importJson(file);
      return false; // 阻止自动上传
    },

    // 导入JSON文件
    importJson(file) {
      const reader = new FileReader();
      const _this = this;

      reader.onload = function(e) {
        try {
          const content = JSON.parse(e.target.result);
          _this.processImportedData(content, file.name);
        } catch (error) {
          _this.$message.error("JSON文件格式错误：" + error.message);
        }
      };

      reader.readAsText(file);
    },

    // 处理导入的数据（针对BMS阈值格式）
    processImportedData(data, fileName) {
      if (data && typeof data === "object") {
        // 设置阈值名称（使用文件名或默认名称）
        this.form.name = fileName.replace(".json", "") || "BMS阈值配置";

        // 清空现有配置
        this.form.configs = [];

        // 遍历对象的所有键值对
        Object.keys(data).forEach(key => {
          const value = data[key];
          // 创建配置项，description默认为空
          const configItem = {
            key: key,
            value: value.toString(), // 转换为字符串
            description: "" // 描述字段留空，让用户自己填写
          };
          this.form.configs.push(configItem);
        });

        this.$message.success(
          `成功导入 ${Object.keys(data).length} 个阈值配置！`
        );
      } else {
        this.$message.error("文件格式不正确，请检查文件内容");
      }
    }
  },
  beforeMount() {
    this.getProjects(this.project.pageNo);
  }
};
</script>

<style lang="less" scoped>
.threshold-form-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.form-container {
  padding: 20px;
  background-color: #fafafa;
  border-radius: 4px;
}

.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00;
}

.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color: #00cc00;
}

.btns {
  padding: 20px;
  background-color: #fafafa;
  border-top: 1px solid #ebeef5;
  border-radius: 0 0 4px 4px;
}

/* 阈值行样式 */
.threshold-row {
  transition: all 0.3s ease;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 8px 0;

  &:hover {
    background-color: #f5f7fa;
    border-color: #ebeef5;
  }

  &.dragging {
    opacity: 0.5;
    border: 1px dashed #409eff;
    background-color: #ecf5ff;
  }

  &.drag-over {
    border-top: 2px solid #409eff;
  }
}

/* 拖拽手柄样式 */
.drag-handle {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: move;

  &:hover {
    color: #409eff;
  }
}

/* 操作按钮样式 */
.action-buttons {
  display: flex;
  align-items: center;
  height: 100%;

  .el-button {
    margin-right: 10px;
    padding: 5px;
    min-height: auto;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      transform: scale(1.1);
    }

    &[disabled] {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        transform: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/thresholdManagement/form.vue